export default __webpack_public_path__ + "camera.asset.5c23861235632528a145e30967afc434.svg";